import React, { useEffect, useRef, useState } from 'react';
import { css } from '@emotion/react';
import { getTicketBookingUrl, initialiseTicketWidget, markTicketWidgetStarted } from '../ticket-widget';

export default function TicketWidget({ html, tickets }) {
  const container = useRef(null);
  const [status, setStatus] = useState('loading');
  const bookingUrl = getTicketBookingUrl(html, tickets);

  useEffect(() => {
    const root = container.current;
    let active = true;
    let timer;
    let ready = false;
    const fail = () => active && setStatus('error');
    const startTimer = () => {
      clearTimeout(timer);
      timer = setTimeout(fail, 15000);
    };
    const checkContent = () => {
      const hasContent = Array.from(root.childNodes).some(node => {
        if (node.nodeType === 3) return !!node.textContent.trim();
        return node.nodeType === 1 && !['SCRIPT', 'STYLE', 'LINK'].includes(node.tagName)
          && (!!node.textContent.trim() || node.matches('iframe') || !!node.querySelector('iframe'));
      });
      if (!active || hasContent === ready) return;
      ready = hasContent;
      setStatus(ready ? 'ready' : 'loading');
      if (ready) clearTimeout(timer);
      else startTimer();
    };

    markTicketWidgetStarted();
    setStatus('loading');
    startTimer();
    const observer = new MutationObserver(checkContent);
    observer.observe(root, { childList: true, subtree: true, characterData: true });

    try {
      const fragment = document.createRange().createContextualFragment(html);
      fragment.querySelectorAll('script, iframe').forEach(element => {
        element.addEventListener('error', fail);
        element.addEventListener('load', () => {
          if (!active || element.id !== 'ft_ftapiJS') return;
          try {
            initialiseTicketWidget(window.ferve);
          } catch {
            fail();
          }
        });
      });
      root.appendChild(fragment);
      checkContent();
    } catch {
      fail();
    }

    return () => {
      active = false;
      clearTimeout(timer);
      observer.disconnect();
      root.innerHTML = '';
    };
  }, [html]);

  return (
    <>
      {status !== 'ready' && <p role="status">
        {status === 'loading' ? 'Loading tickets...' : 'Tickets could not be loaded. Please try again.'}
        {status === 'error' && <button
          type="button"
          onClick={() => window.location.reload()}
          css={css`
            font: inherit;
            color: var(--black);
            background: transparent;
            border: 1px solid var(--black);
            padding: 0.5rem 1rem;
            margin-left: 2rem;
            cursor: pointer;
          `}
        >Reload tickets</button>}
      </p>}
      {status !== 'ready' && bookingUrl && <p><a href={bookingUrl} target="_blank" rel="noopener noreferrer">Book on the ticketing site</a></p>}
      <div ref={container} />
    </>
  );
}
